<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Cálculo de pedidos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Cálculo de pedidos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between align-content-center">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha_desde" [placeholder]="'Desde'" required
              formControlName="fecha_desde"></mdb-date-picker>
            <div *ngIf="
                formHeader.get('fecha_desde').invalid &&
                (formHeader.get('fecha_desde').dirty ||
                formHeader.get('fecha_desde').touched)
              ">
              <mdb-error *ngIf="formHeader.get('fecha_desde').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha_hasta" [placeholder]="'Hasta'" required
              formControlName="fecha_hasta"></mdb-date-picker>
            <div *ngIf="
                formHeader.get('fecha_hasta').invalid &&
                (formHeader.get('fecha_hasta').dirty ||
                formHeader.get('fecha_hasta').touched)
              ">
              <mdb-error *ngIf="formHeader.get('fecha_hasta').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
       
      </div>

      <div class="row filtros-body">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input value="" type="text" id="diasVenta" class="form-control" placeholder="00" required #diasVenta
              formControlName="dia_venta_efectivo" onlyNumbers />
            <label for="diasVenta">Días de venta efectivo</label>
            <div *ngIf="
                    formHeader.get('dia_venta_efectivo').invalid &&
                    (formHeader.get('dia_venta_efectivo').dirty ||
                    formHeader.get('dia_venta_efectivo').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('dia_venta_efectivo').hasError('required')">Ingrese días venta
              </mdb-error>
              <mdb-error *ngIf="formHeader.get('dia_venta_efectivo').hasError('min')">Días venta debe ser mayor a 0
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <input value="" type="text" id="diasStock" class="form-control" placeholder="00" required #diasStock
              formControlName="dia_stock" onlyNumbers />
            <label for="diasStock">Días de stock</label>
            <div *ngIf="
                    formHeader.get('dia_stock').invalid &&
                    (formHeader.get('dia_stock').dirty ||
                    formHeader.get('dia_stock').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('dia_stock').hasError('required')">Ingrese días stock </mdb-error>
              <mdb-error *ngIf="formHeader.get('dia_stock').hasError('min')">Días stock debe ser mayor a 0 </mdb-error>
            </div>
          </div>
        </div>

        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="listaBodega"></mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="listaFamilia"></mdb-select>
            <label>Familia</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_NO_VISTA">
          <div class="md-form">
            <mdb-select [options]="optionsFormComb1" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Formato 1" formControlName="listaFormComb1"></mdb-select>
            <label>Formato 1</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_NO_VISTA">
          <div class="md-form">
            <mdb-select [options]="optionsFormComb2" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Formato 2" formControlName="listaFormComb2"></mdb-select>
            <label>Formato 2</label>
          </div>
        </div>
      </div>

      <div class="row filtros-body">
        <div class="col" style="max-width: 300px;">
          <mdb-checkbox formControlName="producto_venta_cero">Incluir productos con venta 0</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 300px;">
          <mdb-checkbox formControlName="producto_pedido_sugerido">Productos con pedido sugerido</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 300px;">
          <mdb-checkbox formControlName="producto_activo">Productos activos</mdb-checkbox>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>
<div class="row" *ngIf="totalesDocumento">
  <div class="col mt-1">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="blue lighten-5">
        <tr>
          <th scope="col">Stock actual</th>
          <th scope="col">Pedido</th>
          <th scope="col">Monto Pedido $</th>
          <th scope="col">Stock Siguiente</th>
          <th scope="col">Camas</th>
          <!-- <th scope="col">IVA $</th> -->
          <!-- <th scope="col">TOTAL</th> -->
        </tr>
      </thead>
      <tbody class="blue lighten-5">
        <tr>
        <td>{{ totalesDocumento.total_stock_actual | numerico }}</td>
        <td>{{ totalesDocumento.total_pedido | numerico }}</td>
        <td>{{ totalesDocumento.monto_pedido | numerico }}</td>
        <td>{{ totalesDocumento.total_stock_siguiente | numerico }}</td>
        <td>{{ totalesDocumento.total_calculo | numerico }}</td>
        <!-- <td>$ {{ totalesDocumento.iva | numerico }}</td> -->
        <!-- <td><strong>$ {{ totalesDocumento.total | numerico }}</strong></td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaMovimientos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Formato</th>
            <th scope="col">Cantidad vendida</th>
            <!-- <th scope="col" >Monto vendido</th> -->
            <th scope="col">Stock actual</th>
            <th scope="col">Cj/Camas</th>
            <th scope="col">Stock sugerido</th>
            <th scope="col">Stock definitivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let doc of listaMovimientos">
            <td>{{doc.sku}}</td>
            <td>{{doc.producto_nombre}}</td>
            <td>{{doc.formato_nombre}}</td>
            <td>{{doc.cant_vendida | numerico}}</td>
            <!-- <td>$ {{doc.monto_vendido | numerico}}</td> -->
            <td>{{doc.stock_actual | numerico}}</td>
            <td>{{doc.formato_comb_cantidad | numerico}}</td>
            <td>{{doc.stock_sugerido | numerico}}</td>
            <td>
              <!-- {{doc.stock_difinitivo | numerico}} -->
              <div style="display: inline-block;">
                <input type="text" [id]="doc.additionalInfo.index" class="form-control inventario__input-cantidad"
                required onlyNumbers min="0" (input)="onCantidadChange(doc, $event.target.value)"
                [(ngModel)]="doc.stock_difinitivo" #cantidad="ngModel" />
                <mdb-error *ngIf="!doc.additionalInfo.cantidad_valid" style="position: inherit;">
                  Ingrese cantidad
                </mdb-error>
              </div>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>


<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
      Excel
    </button>
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"  (click)="downloadPdf()">
      PDF
    </button>
  </div>
</div>